import { Component, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TagModule } from 'primeng/tag';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TieredMenu, TieredMenuModule } from 'primeng/tieredmenu';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayModule } from 'primeng/overlay';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TabMenuModule } from 'primeng/tabmenu';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenuModule } from 'primeng/menu';
import { IHandhole } from '@rfm/shared-interfaces';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HandholeService } from '../../../../../shared/services/fiber-management/handhole.service.mjs';
import { HandholeEditComponent } from '../handhole-edit/handhole-edit.component';
import { HandholeCreateComponent } from '../handhole-create/handhole-create.component';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-handhole-list',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, ProgressSpinnerModule,TableModule, ConfirmPopupModule, TagModule, CommonModule, FormsModule, ButtonModule, TieredMenuModule, DropdownModule, OverlayModule, OverlayPanelModule, CalendarModule, DividerModule, InputTextModule, TabMenuModule, IconFieldModule, InputIconModule, ConfirmDialogModule, MenuModule, HandholeEditComponent, HandholeCreateComponent],
  templateUrl: './handhole-list.component.html',
  styleUrls: ['./handhole-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService,ConfirmationService]
})
export class HandholeListComponent implements OnInit {
  handholes: IHandhole[] = [];
  isLoading = true;
  menuItems: MenuItem[] = [];
  displayModal: boolean = false;
  displayTaskModal: boolean = false;
  activeTab!: MenuItem;
  items: MenuItem[] | undefined;
  searchValue: string = '';
  dateRange: Date[] = [];  // Expecting an array of two Date objects for range selection
  selectedStatus: string | null = null;
  statusOptions = [{ label: 'Paid', value: 'Paid' }, { label: 'Unpaid', value: 'Unpaid' }];
    orders: Order[] = [
      { client: 'Kathryn Murphy', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Dianne Russell', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Unpaid' },
      { client: 'Jerome Bell', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Albert Flores', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Jane Cooper', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Savannah Nguyen', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Unpaid' },
      { client: 'Darrell Steward', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Jane Cooper', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Paid' },
      { client: 'Brooklyn Simmons', date: this.formatDate('2025-01-06'), order: '#0145', items: '2 items', total: '$0', status: 'Unpaid' }
    ];
    selectedOrder: any;
    // Utility function to format date
    formatDate(dateStr: string): string {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); // "Jan 6, 2025"
    }
    filteredOrders: Order[] = [...this.orders];
    tabs: MenuItem[] = [
      { label: 'All Clients', command: () => this.setActiveTab('All Clients') },
      { label: 'Leads', command: () => this.setActiveTab('Leads') },
      { label: 'Ongoing', command: () => this.setActiveTab('Ongoing') },
      { label: 'Payment Back', command: () => this.setActiveTab('Payment Back') },
      { label: 'Closed', command: () => this.setActiveTab('Closed') },
    ];
  constructor(private handholeService: HandholeService,private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.loadHandholes();
    this.items = [
      { label: 'File', icon: 'pi pi-file' },
      { label: 'Edit', icon: 'pi pi-file-edit' },
      { label: 'Search', icon: 'pi pi-search' }
    ];
    this.activeTab = this.tabs[0];
  }

  loadHandholes(): void {
    this.handholeService.getAll()
      .then((response) => {
        this.handholes = response?.data ?? [];
      })
      .catch((error) => {
        console.error('Error fetching handholes:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  
  setActiveTab(label: string) {
    this.activeTab = this.tabs.find(tab => tab.label === label) || this.tabs[0];
  }
  // Toggle filter overlay panel
  toggleFilter(event: Event, filterPanel: any) {
    filterPanel.toggle(event);
  }
  toggleMenu(event: Event, order: any, menuPanel: any) {
    this.selectedOrder = order; // Store the selected order
    menuPanel.toggle(event); // Open the menu only for the clicked row
  }
 addTask() {
    this.displayTaskModal = true;   // Open modal
  }

  editOrder(order: Order) {
    this.selectedOrder = order; // Pass selected order to modal
    this.displayModal = true;   // Open modal
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this order?',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteOrder();
      }
    });
  }

  deleteOrder() {
    console.log('Deleting order:', this.selectedOrder);
    // Implement delete logic here
  }
  // Apply filters: Status and Date Range
  applyFilters() {
    this.filteredOrders = this.orders.filter(order =>
      (!this.selectedStatus || order.status === this.selectedStatus) &&
      this.isWithinDateRange(order.date)
    );
  }

  // Search function (includes filtering by date and status)
  filterOrders() {
    this.filteredOrders = this.orders.filter(order =>
      (order.client.toLowerCase().includes(this.searchValue.toLowerCase()) ||
       order.order.toLowerCase().includes(this.searchValue.toLowerCase())) &&
      (!this.selectedStatus || order.status === this.selectedStatus) &&
      this.isWithinDateRange(order.date)
    );
  }

  // Check if the order date is within the selected date range
  isWithinDateRange(orderDate: string): boolean {
    if (!this.dateRange || this.dateRange.length !== 2) {
      return true; // No date range selected, show all orders
    }

    // Convert order date from "Jan 6, 2025" to a Date object
    const parsedOrderDate = new Date(Date.parse(orderDate));

    // Convert the selected date range to timestamps
    const startDate = new Date(this.dateRange[0]).setHours(0, 0, 0, 0);
    const endDate = new Date(this.dateRange[1]).setHours(23, 59, 59, 999);

    return parsedOrderDate.getTime() >= startDate && parsedOrderDate.getTime() <= endDate;
  }
  closeEditModal() {
    this.displayModal = false;  // Close modal
  }
  closeTaskModal() {
    this.displayTaskModal = false;  // Close modal
  }
}
